module.exports = "https://web-assets.ifttt.com/packs/media/perks/calendar-a3e476db.svg";